export interface PackageDetail {
  id: string;
  packageId: number;
  durationId: number;
  duration: string;
  validityDays: number;
  price: number;
}

export interface Package {
  id: string;
  title: string;
  name: string;
  description: string;
  numberOfUsers: number;
  createdAt?: string;
  updatedAt?: string;
  color: string;
  isIndividual: boolean;
  details?: PackageDetail[];
}

/** Get the detail row for a duration (e.g. "Monthly" or "Yearly"). */
export function getDetailByDuration(
  pkg: Package,
  isYearly: boolean
): PackageDetail | undefined {
  const durationId = isYearly ? 21 : 20;
  const duration = isYearly ? "Yearly" : "Monthly";
  return pkg.details?.find(
    (d) =>
      Number(d.durationId) === durationId ||
      d.duration?.toLowerCase() === duration.toLowerCase()
  );
}

/** Get price for a package for the given billing period. */
export function getPriceByDuration(pkg: Package, isYearly: boolean): number {
  const detail = getDetailByDuration(pkg, isYearly);
  return detail != null ? Number(detail.price) : 0;
}

/** True if the package has zero price for monthly (demo/free). */
export function isDemoPackage(pkg: Package): boolean {
  const monthly = getDetailByDuration(pkg, false);
  return monthly != null && Number(monthly.price) === 0;
}
